import Tracker from './Tracker'
import buildURL from '../../utils/buildURL'

class GoogleTagManager extends Tracker {
  dataLayer = 'wlDataLayer'

  async init() {
    const { params, env, gtmId, useGtag = false } = this.props
    const paramsEnv = params?.[env] ?? {}

    /* istanbul ignore next */
    !(function (w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== 'dataLayer' ? '&l=' + l : ''
      j.async = true
      j.src = buildURL(
        `https://www.googletagmanager.com/${useGtag ? 'gtag/js' : 'gtm.js'}?id=` + i + dl,
        paramsEnv
      )
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', this.dataLayer, gtmId)
  }

  event(event, firstLoad, ...args) {
    // eslint-disable-next-line no-unused-vars
    const { renderEvent, clearRenderEvent, ...appState } = this.props.applicationState
    window[this.dataLayer] = window[this.dataLayer] || /* istanbul ignore next */ []

    // if event value is 'true', send entire application state
    if (this.props.events[event] === true) {
      window[this.dataLayer].push({
        event,
        ...appState,
      })
    } else if (args.length === 1 && typeof args[0] === 'object') {
      window[this.dataLayer].push({
        event,
        ...args[0],
      })
    } else {
      window[this.dataLayer].push(args)
    }
  }
}

export default GoogleTagManager
